Bacon = require 'baconjs'
React     = require 'react'
R = require 'ramda'
client = require 'api/auth'
{ AuthV5Api } = require 'api/auth-v5'
Dispatcher = require 'utils/dispatcher'
tzdetect = require('utils/tzdetect')
{ wrapRequest } = require 'utils/request'

# TODO: Push to toaster
toastr = require('components/toastr-config')

# ---- session state (chef-style: v5 get_auth_token + localStorage 'me') ----
ME_KEY = 'me'

id = null
name = null
email = null
roles = []
acls = {}

# once logged in push true on this prop
loggedIn = new Bacon.Bus

savedLists = localStorage.getItem('lists')
if savedLists and JSON.parse(savedLists).length > 0
  lists = Bacon.once JSON.parse savedLists
else
  lists = Bacon.once []

# old-style roles are derived: root access group (id 1, parent null) = config/support
LEGACY_ROLES =
  restaurants: 'restaurant'
  restaurants_admin: 'restaurant_admin'
  channels: 'channel'

deriveRoles = (user) ->
  mapped = R.map ((r) -> LEGACY_ROLES[r] or r), (user.ag_roles or [])
  isRoot = user.access_group_ids and user.access_group_ids[0] == 1
  if isRoot then R.uniq R.concat ['config', 'support'], mapped else mapped

populate = (user) ->
  id = user.id
  name = user.name
  email = user.email
  roles = deriveRoles user
  localStorage.setItem ME_KEY, JSON.stringify user
  client.seedSession user
  setupExpirationWatch user

applySession = (user) ->
  populate user
  loggedIn.push true

readMe = ->
  try
    JSON.parse localStorage.getItem(ME_KEY)
  catch
    null

isNotExpired = (user) ->
  user?.token_expires_at and user.token_expires_at > (Date.now() / 1000)

refreshTimer = null
setupExpirationWatch = (user) ->
  # chef behavior: reload at expiry. Boot then refreshes the token and every
  # render-time token capture re-reads the fresh session store
  if refreshTimer then clearTimeout refreshTimer
  ms = (user.token_expires_at * 1000) - Date.now()
  refreshTimer = setTimeout (-> window.location.reload()), (if ms > 0 then ms else 0)

hasRole = (role) -> R.contains(role, roles)
hasAnyRole = (roles...) -> R.any hasRole, roles

login = (email, password) ->
  # reload after login (like the old OAuth redirect): render-time token
  # captures only re-read the session on a fresh boot
  AuthV5Api.getAuthToken(email, password).then(applySession).then -> window.location.reload()

requestOtp = (phone) ->
  AuthV5Api.requestSignInOtp phone

verifyOtp = (phone, code) ->
  AuthV5Api.verifySignInOtp(phone, code).then(applySession).then -> window.location.reload()

logout = ->
  if refreshTimer then clearTimeout refreshTimer
  localStorage.removeItem ME_KEY
  client.clearSession()
  id = name = email = null
  roles = []
  acls = {}
  loggedIn.push false

# ---- boot: derive the property's initial value synchronously ----
# A Bus event pushed at module load is lost (no subscribers yet), so the
# session state must be baked into the property's initial value instead.
bootMe = readMe()
bootState =
  if not bootMe then 'logged-out'
  else if isNotExpired bootMe then 'logged-in'
  else if bootMe.refresh_token then 'refreshing'
  else 'logged-out'

loggedInProp = switch bootState
  when 'logged-in'
    populate bootMe
    loggedIn.toProperty true
  when 'refreshing'
    # no initial value: subscribers show a loading state until the refresh resolves
    loggedIn.toProperty()
  else
    if bootMe
      localStorage.removeItem ME_KEY
      client.clearSession()
    loggedIn.toProperty false

if bootState == 'refreshing'
  AuthV5Api.refreshToken(bootMe.refresh_token)
    .then applySession
    .catch (err) ->
      if err?.status == 400
        localStorage.removeItem ME_KEY
        client.clearSession()
      loggedIn.push false

# TODO: Implement user settings
d = new Dispatcher("user")
userPreferences = {}
timezone = "Asia/Calcutta"

getLocalStorageItem = (key) ->
  localStorage.getItem(key)

localUserPreferences = (key) ->
  Bacon.once(key).map(getLocalStorageItem)

loadUserPreferencesCall = (key) ->
  # Promise.resolve().then: a synchronous throw inside client.api must not
  # abort the loggedIn dispatch chain - make it a rejection instead
  Bacon
    .fromPromise(wrapRequest(Promise.resolve().then(-> client.api("settings", 'get', { project: 'customer-service', key: key }))))

remoteUserPreferences = (key) ->
  Bacon
    .retry
      source: -> loadUserPreferencesCall(key)
      retries: 5
      isRetryable: (error) -> error.status.code != 404
      delay: ({retriesDone}) -> retriesDone * 100
    .map(R.prop('settings'))

saveRemote = R.curry (key, value) ->
  Bacon.fromPromise wrapRequest client.api "settings", 'put',
    project: 'customer-service'
    key: key
    settings: JSON.stringify(value)

saveSettingsFor = (key) ->
  d
    .stream(key)
    .skipDuplicates(R.quals)
    .throttle(500)
    .flatMap(saveRemote(key))

loadSettings = R.curry (key, defaultValue) ->
  loggedInProp
    .filter (b) -> !!b
    .flatMap -> remoteUserPreferences(key)
    .flatMapError (error) ->
      # console.log "ERROR", error, arguments
      # toastr.error "There was an error trying while loading settings. Please contact support!<br/><br/>#{error.status.code} - #{error.status.message}", "Settings#Users", {timeOut: 0}
      new Bacon.Next(defaultValue)
    .map JSON.parse
    .toEventStream()

userSettings = Bacon.update { timezone: tzdetect.guess(), settings: {}, tabs: [] },
  [loadSettings('user_settings', '{}')], ({tabs, timezone}, settings) -> {tabs, timezone, settings}
  [loadSettings('tabs', '[]')], ({timezone, settings}, tabs) -> {tabs, timezone, settings}
  [loadSettings('timezone', 'null')], ({settings, tabs}, timezone) -> {tabs, timezone, settings}

userSettings
  .map(R.prop('settings'))
  .onValue (settings) ->
    userPreferences = settings || {}

userSettings
  .map R.prop('timezone')
  .onValue (tz) ->
    timezone = tz

# Saving app state
saveAppState = Bacon
  .once ['user_settings', 'tabs', 'timezone']
  .map R.map saveSettingsFor
  .flatMap Bacon.mergeAll

saveAppState
  .onValue (data) ->
    # toastr.error "There was an error trying to save settings. Please contact support!", "Settings"

saveAppState
  .onError (data) ->
    toastr.error "There was an error trying to save settings. Please contact support!", "Settings"

userSetting = (name) ->
  if userPreferences[name] != undefined
    userPreferences[name]
  else
    setUserSetting name, true

setUserSetting = (name, value) ->
  userPreferences[name] = value
  d.stream('user_settings').push userPreferences
  value

# END USER SETTINGS

module.exports =
  id: -> id
  name: -> name
  email: -> email
  roles: -> roles
  acls: -> acls
  login: login
  requestOtp: requestOtp
  verifyOtp: verifyOtp
  loggedIn: loggedInProp
  hasRole: hasRole
  hasAnyRole: hasAnyRole
  lists: lists

  settingFor: userSetting
  setSettingFor: setUserSetting
  settings: -> userPreferences
  saveSettings: (prefs) ->
    userPreferences = prefs
    d.stream('user_settings').push prefs
  resetSettings: ->
    d.stream('tabs').push []
    d.stream('user_settings').push {}

  timezone: -> tzdetect.guess()
  saveTimezone: (tz) ->
    timezone = tz
    d.stream('timezone').push tz

  tabs: userSettings
    .map(R.prop('tabs'))
    .map R.defaultTo([])
  saveTabs: (tabs) ->
    d.stream('tabs').push tabs.slice(0, 10)

  logout: logout